<template>
  <div class="container">
   
    <div class="introWindow">
      <q-table
        ref="table"
        title="Summary"
        :data="data"
        :columns="columns"
        row-key="index"
        no-data-label="No Result Found"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :props="props"
            class="cursor-pointer"
          >
             <q-td key="index" :props="props">
              {{
                props.row.index != null && props.row.index != undefined
                  ? props.row.index+1
                  : "No data"
              }}
            </q-td>

            <q-td key="item_key" :props="props">
              {{
                props.row["Product ID"] != null && props.row["Product ID"] != undefined
                  ? props.row["Product ID"]
                  : "No data"
              }}
            </q-td>

            <q-td key="store_key" :props="props">
              {{
                props.row["Store Name"] != null && props.row["Store Name"] != undefined
                  ? props.row["Store Name"]
                  : "No data"
              }}
            </q-td>
            <q-td key="product_name" :props="props">
              {{
                props.row["Product Name"] != null && props.row["Product Name"]!= undefined
                  ? props.row["Product Name"]
                  : "No data"
              }}
            </q-td>

            
            <q-td key="MRP" :props="props">
              ₹
              {{
                props.row.MRP != null &&
                props.row.MRP != undefined
                  ? props.row.MRP.toFixed(2)
                  : "No data"
              }}
            </q-td>
            <q-td key="actual_selling_price" :props="props">
              ₹
              {{
                props.row["Selling Price(SP)"] != null &&
                props.row["Selling Price(SP)"] != undefined
                  ? props.row["Selling Price(SP)"].toFixed(2)
                  : "No data"
              }}
            </q-td>

           

            <q-td key="optimal_price" :props="props">
              ₹
              {{
                props.row["Recommended Price(RP)"] != null &&
                props.row["Recommended Price(RP)"] != undefined
                  ? props.row["Recommended Price(RP)"].toFixed(2)
                  : "No data"
              }}
            </q-td>

             <q-td key="actual_quantity" :props="props">
              {{
                props.row["Predicted Demand at SP"] != null &&
                props.row["Predicted Demand at SP"] != undefined
                  ? Math.trunc(props.row["Predicted Demand at SP"])
                  : "No data"
              }}
            </q-td>

             <q-td key="constr_demand" :props="props">
              {{
                props.row["Predicted Demand at RP"] != null && props.row["Predicted Demand at RP"] != undefined
                  ? Math.trunc(props.row["Predicted Demand at RP"])
                  : "No data"
              }}
            </q-td>

            <q-td key="confidence_range" :props="props">
              <span v-if="'insufficient_data' === props.row.confidence_range"
                ><div class="box-i">
                  <strong>Insufficient Data</strong>
                </div>
              </span>
              <span
                v-if="
                  'high' === props.row.confidence_range ||
                  'very_high' === props.row.confidence_range
                "
                ><div class="box-h">
                  <strong>High</strong>
                </div>
              </span>
              <span v-if="'low' === props.row.confidence_range"
                ><div class="box-l">
                  <strong>Low</strong>
                </div>
              </span>
              <span v-if="'medium' === props.row.confidence_range"
                ><div class="box-m">
                  <strong>Medium</strong>
                </div></span
              >
            </q-td>

           
            
             

            
            <q-td key="revenue" :props="props">
              ₹
              {{
                props.row["revenue"]!= null &&
                props.row["revenue"] != undefined
                  ? props.row["revenue"].toFixed(2)
                  : "No data"
              }}
            </q-td>
            


            
           


            <!-- <q-td key="end_stock" :props="props">
               {{(props.row.end_stock)!=null && (props.row.end_stock)!= undefined ?(props.row.end_stock).toFixed(2):"No data" }}
            </q-td> -->

            <q-td key="percentage_volume_increase" :props="props">
              {{
                props.row["Percentage Volume Increase"] != null &&
                props.row["Percentage Volume Increase"] != undefined
                  ? props.row["Percentage Volume Increase"].toFixed(2)
                  : "No data"
              }}
              %
            </q-td>

            <!-- <q-td key="coefficient_of_variation" :props="props">
              {{(props.row.coefficient_of_variation)!=null && (props.row.coefficient_of_variation)!= undefined ?(props.row.coefficient_of_variation).toFixed(2):"No data" }} 
            </q-td> -->
          </q-tr>
        </template>
      </q-table>

      <div class="panel">
        <div class="panel-body">
          <div class="categories">
            <div class="category">
              <span>Recommended Price(RP)</span>
              <span class="price_align"
                >
                {{
                  items["Recommended Price(RP)"] != null &&
                  items["Recommended Price(RP)"] != undefined
                    ? items["Recommended Price(RP)"].toFixed(2)
                    : "No data"
                }}
              </span>
            </div>
            <div class="category">
              <span>Predicted Demand at RP</span>
              <span class="price_align">{{
                items["Predicted Demand at RP"] != null &&
                items["Predicted Demand at RP"] != undefined
                  ? Math.trunc(items["Predicted Demand at RP"])
                  : "No data"
              }}</span>
            </div>
            <div class="category">
              <span>Predicted Revenue at RP</span>
              <span class="price_align"
                >
                {{
                  items["revenue"] != null && items["revenue"] != undefined
                    ? items["revenue"].toFixed(2)
                    : "No data"
                }}</span
              >
            </div>
            <div class="category">
              <span>Percentage Volume Increase</span>
              <span class="price_align"
                >{{
                  items["Percentage Volume Increase"] != null &&
                  items["Percentage Volume Increase"] != undefined
                    ? items["Percentage Volume Increase"].toFixed(2)
                    : "No data"
                }}
                %</span
              >
            </div>
          </div>
          <!-- <img src="s3://uniqin-ml-artifacts/test/plots/('lego-dino.myshopify.com', '6793950494908')comparison.png" alt="" srcset=""> -->

          <LineChart class="chart" />
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import LineChart from "../reuseable/LineChart.vue";
export default {
  name: "VolumeSummary",
  components: { LineChart },
  props: ["items","jobid"],
  mounted(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });
      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/volume-summary");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
        this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/volume-summary");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/volume-summary");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
    },
  
  data() {
    return {
      columns: [
        // {
        //   name: "index",
        //   required: true,
        //   label: "Index",
        //   align: "center",
        //   field: "index",
        //   classes: "bg-grey-2 ellipsis",
        //   style: "max-width: 100px",
        //   headerClasses: "bg-primary text-white",
        //   sortable: true,
        // },
      {
          name: "item_key",
          label: "Product ID",
          field: "item_key",
          align: "center",
          sortable: true,
        },
        {
          name: "store_key",
          label: "Store Name",
          field: "store_key",
          align: "center",
          sortable: true,
        },
        {
          name: "product_name",
          label: "Product Name",
          field: "product_name",
          align: "center",
          sortable: true,
        },
        {
          name: "MRP",
          label: "MRP",
          field: "MRP",
          align: "center",
        },
         {
          name: "actual_selling_price",
          label: "Selling Price(SP)",
          field: "actual_selling_price",
          align: "center",
        },
       
        {
          name: "optimal_price",
          label: "Recommended Price(RP)",
          field: "optimal_price",
          align: "center",
        },
         {
          name: "actual_quantity",
          label: "Predicted Demand at SP",
          field: "actual_quantity",
          align: "center",
        },
        {
          name: "constr_demand",
          label: "Predicted Demand at RP",
          field: "constr_demand",
          align: "center",
        },
        {
          name: "confidence_range",
          label: "Confidence Range",
          field: "confidence_range",
          align: "center",
        },
        
        
        
         
        {
          name: "revenue",
          label: "Predicted Revenue at RP",
          field: "revenue",
          align: "center",
        },
        
        
       
        // { name: "end_stock", label: "End Stock", field: "end_stock",align: "center", },
        {
          name: "percentage_volume_increase",
          label: "Percentage Volume Increase",
          field: "percentage_volume_increase",
          align: "center",
        },
      ],
      data: [this.items],
      jobidb:this.jobid,
       currencySymbol:{
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$'
},
    };
  },
};
</script>   

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.box-i {
  align-items: center;
  background-color: #000000;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-h {
  align-items: center;
  background-color: #2db051;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 4rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-l {
  align-items: center;
  background-color: #e40017;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 4rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-m {
  align-items: center;
  background-color: #fb9300;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 4rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.row {
  margin-top: 1rem;
}
.introWindow {
  text-align: center;
  border-radius: 4px;
  padding: 1rem 1rem 0;
  background: transparent;
  transition: 0.3s;
}
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.panel {
  position: relative;
  width: 100%;
  height: 450px;
  background: white;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 1rem;
  padding: 1rem;
  overflow: hidden;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  height: 60px;
  background: #fff;
}
.title {
  color: #5e6977;
  font-weight: 500;
}
.price_align {
  text-align: center;
  margin-right: 0.4rem;
}
.calendar-views span {
  font-size: 14px;
  font-weight: 300;
  color: #bdc6cf;
  padding: 6px 14px;
  border: 2px solid transparent;
}
.panel-body {
  display: flex;
  height: 340px;
  padding-bottom: 10px;
}
.categories {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-basis: 25%;
  padding: 39px 5px 41px 26px;
  margin-right: 5px;
  margin-left: 5px;
}
.category {
  display: flex;
  flex-direction: column;
}
.category span:first-child {
  font-weight: 400;
  font-size: 14px;
  opacity: 0.8;
  color: rgb(53, 51, 51);
  margin-bottom: 6px;
}
.category span:last-child {
  font-size: 32px;
  font-weight: 300;
  color: rgb(6, 78, 233);
}
.chart {
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  position: relative;
  float: left;
  margin-left: 2rem;
}
.operating-systems {
  display: flex;
  justify-content: space-between;
  width: 512px;
  margin-top: 30px;
  margin-bottom: 50px;
}
span[class*="-os"] {
  font-size: 14px;
  font-weight: 300;
  font-size: 14px;
  color: #1c1c1d;
}
span[class*="-os"] span {
  width: 9px;
  height: 9px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 9px;
}
.android-os span {
  background: #80b354;
}
.ios-os span {
  background: #f5a623;
}
.windows-os span {
  background: #f8e71c;
}
div[class*="-stats"] {
  position: absolute;
  color: #fff;
  font-size: 12px;
  display: flex;
  opacity: 0;
  animation: showstats 0.6s linear 1.8s;
  animation-fill-mode: forwards;
}
div[class*="-stats"] span {
  height: 12px;
  width: 12px;
  margin: 0 7px;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 50%;
}
.android-stats {
  bottom: 155px;
  right: 230px;
}
.ios-stats {
  bottom: 83px;
  left: 133px;
}
.windows-stats {
  bottom: 133px;
  right: 62px;
}
div[class*="-stats"] span:hover {
  transform: scale(1.4) rotate(0.02deg);
  border: 2px solid #fff;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}
.android-stats span:hover {
  background: #80b354;
}
.ios-stats span:hover {
  background: #f5a623;
}
.windows-stats span:hover {
  background: #f8e71c;
}
.dataset-1 {
  animation: raise 0.8s linear 1;
  transform-origin: bottom;
}
.dataset-2 {
  animation: raise 1.6s linear 1;
  transform-origin: bottom;
}
.dataset-3 {
  animation: raise 1.8s linear 1;
  transform-origin: bottom;
}
.lines {
  opacity: 0;
  animation: showlines 0.6s linear 1.6s;
  animation-fill-mode: forwards;
}
@keyframes showlines {
  to {
    opacity: 0.2;
  }
}
@keyframes showstats {
  to {
    opacity: 1;
  }
}
@keyframes raise {
  0% {
    transform: scaleY(0.01);
  }
  75% {
    transform: scaleY(1.1);
  }
  100% {
    transform: scaleY(1);
  }
}
</style>